<template>
    <main class="flex-1 relative pb-8 z-0 overflow-y-auto">
        <PageHeader>
            <h1 class="ml-3 text-2xl font-bold text-gray-900 sm:truncate flex flex-row justify-between w-full">
                <span>
                    <span class="flex flex-row items-center">
                        Domains
                        <Loader v-if="isFetchPending" class="h-6 w-6 m-2 border-2 -red -sm"/>
                    </span>
                    <LangSwitcher />
                </span>
            </h1>
        </PageHeader>

        <div class="mt-8 lg:max-w-6xl lg:mx-auto">
            <p class="ml-3 text-sm text-gray-600">Tous les domaines. Ouvrez-en un pour activer ou désactiver la maintenance.</p>
            <div class="m-4">
                <Search
                    v-model="search"
                    @update:modelValue="handleSearchChange"
                />

                <List
                    :items="domains"
                    :columns="columns"
                    :desc="desc"
                    @manageItem="handleManageDomain"
                    @sortBy="handleSortBy"
                    manageable
                />

                <Pagination
                    v-if="lastPage > 1"
                    :current_page="currentPage"
                    :last_page="lastPage"
                    @change="handleChangePage"
                />
            </div>
        </div>
    </main>
</template>

<script>
import PageHeader from "../../components/partials/page-header";
import Loader from "../../components/partials/loader";
import Pagination from "../../components/partials/pagination";
import Search from "../../components/partials/search";
import List from "../../components/partials/list";
import LangSwitcher from "../../components/partials/lang-switcher";
import { isGuestMaintenanceEnabled } from "../../composables/guestMaintenance";

export default {
    data() {
        return {
            sort_by: null,
            desc: false,
            search: null,
        }
    },
    computed: {
        locale() {
            return this.$store.state.config.locale;
        },
        isFetchPending() {
            return this.$store.state.domains.isFetchListPending;
        },
        domains() {
            return this.$store.state.domains.list.map((domain) => ({
                ...domain,
                maintenance: isGuestMaintenanceEnabled(domain.settings && domain.settings.data),
            }));
        },
        lastPage() {
            return this.$store.state.domains.pagination.last_page;
        },
        currentPage() {
            return this.$store.state.domains.pagination.current_page;
        },
        columns() {
            return {
                id: {},
                ['translatable.name.' + this.locale]: {
                    sortable: true,
                    sortBy: 'name',
                    label: 'Nom',
                },
                host: {
                    label: 'Hôte',
                },
                maintenance: {
                    label: 'Maintenance',
                    filter: 'maintenanceBadge',
                },
            }
        },
    },
    mounted() {
        this.fetchDomains();
    },
    methods: {
        fetchDomains(page = 1) {
            const search = this.search ? { name: this.search } : {};

            this.$store.dispatch('domains/getList', {
                page,
                search,
                sort_by: this.sort_by,
                desc: this.desc,
                includes: ['settings'],
            });
        },
        handleChangePage(page = this.currentPage) {
            this.fetchDomains(page);
        },
        handleSortBy(type) {
            this.desc = !this.desc;
            this.sort_by = type;
            this.fetchDomains();
        },
        handleSearchChange(search) {
            this.search = search;
            this.fetchDomains();
        },
        handleManageDomain(domain) {
            this.$router.push({ name: 'domain-show', params: { id: domain.id } });
        },
    },
    components: {
        PageHeader,
        Loader,
        Pagination,
        Search,
        List,
        LangSwitcher,
    }
}
</script>
